import {
    FETCH_HELP_TOPICS_REQUEST,
    FETCH_HELP_TOPICS_SUCCESS,
    FETCH_HELP_TOPICS_FAILURE,
} from "../actions/types";

const initialState = {
    helpTopics: [],
    loading: false,
    error: null,
};

const helpTopicReducer = (
    state =
        initialState,
    action
) => {
    switch (
        action.type
    ) {
        case FETCH_HELP_TOPICS_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };

        case FETCH_HELP_TOPICS_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                helpTopics:
                    action.payload,
            };

        case FETCH_HELP_TOPICS_FAILURE:
            return {
                ...state,
                loading: false,
                error:
                    action.payload,
            };

        default:
            return state;
    }
};

export default helpTopicReducer;